// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3jyCY","inner":"Footer_inner__2Xl4S"};